import { Injectable } from '@angular/core';
import { InMemoryHttpClient } from './in-memory-http-client';
import { Observable } from 'rxjs';
import { RequestInfo, ResponseOptions, STATUS } from 'angular-in-memory-web-api';
import moment from 'moment';
import {
  FootfallHourlyPredictionResponse,
  FootfallPredictionResponse
} from '../../../interfaces/response/PredictionsResponses';

/**
 * This service intercepts {@link FootfallPredictionService} requests and redirects them to an in-memory data store.
 */
@Injectable({
  providedIn: 'root'
})
export class InMemoryFootfallPredictionsDataService implements InMemoryHttpClient {

  /**
   * Intercepts HTTP DELETE request of {@link FootfallPredictionService}.
   * @param reqInfo information about the current HTTP DELETE request.
   */
  delete(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }

  /**
   * Intercepts HTTP GET request of {@link FootfallPredictionService}. Gets all required records from an in-memory data store.
   * @param reqInfo information about the current HTTP GET request.
   */
  get(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return reqInfo.utils.createResponse$(() => {
      const fromDate = reqInfo.query.get('fromDate')[0];
      const toDate = reqInfo.query.get('toDate')[0];
      return {
          body: this.getFootfallPredictions(fromDate, toDate),
          status: STATUS.OK
        };
      }
    );
  }

  /**
   * Intercepts HTTP POST request of {@link FootfallPredictionService}.
   * @param reqInfo information about the current HTTP POST request.
   */
  post(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }

  /**
   * Intercepts HTTP PUT request of {@link FootfallPredictionService}.
   * @param reqInfo information about the current HTTP PUT request.
   */
  put(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }

  /**
   * Intercepts HTTP PATCH request of {@link FootfallPredictionService}.
   * @param reqInfo information about the current HTTP PATCH request.
   */
  patch(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }

  private getFootfallPredictions(fromDate: string, toDate: string): FootfallPredictionResponse[] {
    const predictions: FootfallPredictionResponse[] = [];
    for (let date = moment(fromDate); date <= moment(toDate); date = date.add(1, 'day')) {
      predictions.push({
        date: date.format('YYYY-MM-DD'),
        hourlyPredictions: this.getFootfallHourlyPredictions()
      });
    }
    return predictions;
  }

  private getFootfallHourlyPredictions(): FootfallHourlyPredictionResponse[] {
    const hours = [9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
    const hourlyPredictions: FootfallHourlyPredictionResponse[] = [];

    hours.forEach((hour) => {
      hourlyPredictions.push({
        hour,
        prediction: this.randomIntFromInterval(15, 30)
      });
    });

    return hourlyPredictions;
  }

  private randomIntFromInterval(min: number, max: number) {
    return Math.random() * (max - min + 1) + min;
  }
}
